import { FC } from 'react';
import { Heading, Paragraph, Button, Card } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { SealQuestion } from '@phosphor-icons/react';
import { getGCLIDParameters } from 'domains/tracking/GCLIDtracking';
import { getUTMParameters } from 'domains/tracking/UTMTracking';
import { useSignupDirectCtx } from '../context';

type Props = {
  onBailoutToConsult?: () => void;
};

const JOTFORM_BAILOUT = 'https://forms.expressable.com/251055433478963';

const Component: FC<Props> = ({ onBailoutToConsult }) => {
  const { t } = useTranslation();

  const signupDirectCtx = useSignupDirectCtx();

  const { resumedLeadState, filters } = signupDirectCtx;

  if (!filters) throw 'Expected filters to be set';

  const state = filters.stateCode;
  const pid = filters.paymentMethod.type === 'insurance' ? filters.paymentMethod.insuranceData.entryId : '';
  const leadID = resumedLeadState?.leadID;
  const GCLIDParams = getGCLIDParameters();
  const gclid = GCLIDParams?.gclidTracker;
  const UTMParams = getUTMParameters();
  const { utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = UTMParams;

  const handleClick = () => {
    const allTheParams = {
      state: state || '',
      pid: pid || '',
      leadID: leadID || '',
      gclid: gclid || '',
      utmSource: utmSource || '',
      utmTerm: utmTerm || '',
      utmCampaign: utmCampaign || '',
      utmMedium: utmMedium || '',
      utmContent: utmContent || '',
    };

    const paramsWithValue = Object.fromEntries(Object.entries(allTheParams).filter(([, value]) => value !== ''));

    const params = new URLSearchParams(paramsWithValue);

    // Track the click
    onBailoutToConsult?.();

    window.location.replace(`${JOTFORM_BAILOUT}?${params.toString()}`);
  };

  return (
    <>
      <Card
        className="my-20 p-e40 mobile-d:p-e32 desktop:my-20 border border-warm-gray-200 justify-center items-center"
        variant="secondary"
      >
        <Heading level="h6" className="flex items-center -ml-8">
          <div className="p-e12 rounded-full bg-orchid-50 text-purple-500 mx-8">
            <SealQuestion weight="fill" size={20} />
          </div>
          {t('directSignup.schedule.switchToConsult.bailout.heading')}
        </Heading>
        <div className="flex justify-evenly gap-40 md:gap-e56 flex-wrap">
          <Paragraph size="md">{t('directSignup.schedule.switchToConsult.bailout.copy')}</Paragraph>
        </div>
        <Button
          data-testid="check-insurance-eligibility-button"
          size="md"
          variant="secondary"
          className="mt-32"
          onClick={handleClick}
        >
          {t('directSignup.schedule.switchToConsult.CTA')}
        </Button>
      </Card>
    </>
  );
};

export const SignupConsultationBailout = Component;
